import { useTranslation } from '@sm360/hooks'
import React from 'react'

const TermsTableHeader = () => {
    const { t } = useTranslation()

    return (
        <div className='pc-termsTableHeader'>
            <span className='pc-termsTableHeader__col'>{t('pc.term')}</span>
            <span className='pc-termsTableHeader__col'>{t('pc.rate')}</span>
            <span className='pc-termsTableHeader__col'>{t('pc.payment')}</span>
        </div>
    )
}

export default TermsTableHeader
